import React from "react";
import { useMemo } from "react";

const quotes = [
  "We're saving powerpoints, not lives.",
  "Remember, the company won't cry at your funeral.",
  "The reward for solving a problem is being assigned two more.",
  "If you died today, your job would be posted before your obituary.",
  "Your hard work fuels someone else's yacht payments.",
  "Corporate values: We care deeply about you, as long as you hit Q4 targets.",
  "No one's last words were 'I wish I'd attended more Zoom meetings.'",
  "No one writes 'they always hit their KPIs' on a tombstone.",
];

export function QuoteBlock() {
  const todayQuote = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const dayOfYear = Math.floor(
      (now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
    );
    return quotes[dayOfYear % quotes.length];
  }, []);

  return (
    <div className="animate-fade-in bg-emerald-400 dark:bg-emerald-700/50 rounded-3xl border-2 border-emerald-500 dark:border-emerald-600 p-8 relative overflow-hidden">
      <p 
        className="text-[clamp(1.5rem,4vw,2.5rem)] leading-tight font-semibold text-black dark:text-white"
        style={{ 
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {todayQuote}
      </p>
    </div>
  );
}